import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignupView from '@/views/SignupView.vue'
import AppointmentView from '@/views/AppointmentView.vue'
import categorieView from '@/views/CategorieView.vue'
import BookingView from '@/views/BookingView.vue'
import UserAccountView from '@/views/UserAccount.vue'
import SearchView from '@/views/SearchView.vue'
import SalonDetail from '@/views/SalonDetail.vue'
import LoginPro from '@/views/LoginPro.vue'
import CguClient from '@/views/CguClient.vue'
import CgvClient from '@/views/CgvClient.vue'
import PolitiqueConfidentialite from '@/views/PolitiqueConfidentialite.vue'
import MentionsLegales from '@/views/MentionsLegales.vue'
import CguCgvPros from '@/views/CguCgvPros.vue'
import GoogleCallbackView from '@/views/GoogleCallbackView.vue'
import CityPageView from '@/views/CityPageView.vue'
import ActivityCityView from '@/views/ActivityCityView.vue'
import PaymentConfirmation from '@/views/PaymentConfirmation.vue'
import PaymentCancellation from '@/views/PaymentCancellation.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/rendez-vous/:id',
    name: 'appointment',
    component: AppointmentView,
    meta: { requiresAuth: true }
  },
  {
    path: '/mes-rendez-vous',
    name: 'booking',
    component: BookingView
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/auth/google/callback',
    name: 'GoogleCallback',
    component: GoogleCallbackView,
    meta: {
      public: true,
      skipCityCheck: true
    }
  },
  {
    path: '/categorie',
    name: 'categorie',
    component: categorieView
  },
  {
    path: '/services/:categorie',
    name: 'ServiceCategory',
    component: () => import('@/views/ServiceCategory.vue'),
  },
  {
    path: '/espace-pro',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }, 
  {
    path: '/userAccount',
    name: 'userAccount',
    component: UserAccountView,
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView
  },
  // SEO Routes: Salon detail avec alias textuel (slug)
  {
    path: '/etablissement/:slug',
    name: 'SalonDetailSlug',
    component: SalonDetail,
    meta: {
      seoPage: true,
      prerender: true
    }
  },
  // Ancienne route salon (conservée pour la rétrocompatibilité)
  {
    path: '/salon/:id',
    name: 'SalonDetail',
    component: SalonDetail
  },
  {
    path: '/espace-pro/LoginPro',
    name: 'LoginPro',
    component: LoginPro
  },
  {
    path: '/cgu',
    name: 'cgu',
    component: CguClient
  },
  {
    path: '/cgv',
    name: 'cgv',
    component: CgvClient
  },
  {
    path: '/PolitiqueConfidentialite',
    name: 'PolitiqueConfidentialite',
    component: PolitiqueConfidentialite
  },
  {
    path: '/MentionsLegales',
    name: 'MentionsLegales',
    component: MentionsLegales
  },
  {
    path: '/espace-pro/cgu-cgv',
    name: 'cguPro',
    component: CguCgvPros
  },
  {
    path: '/confirmation',
    name: 'PaymentConfirmation',
    component: PaymentConfirmation,
    meta: {
      public: true
    }
  },
  {
    path: '/annulation',
    name: 'PaymentCancellation',
    component: PaymentCancellation,
    meta: {
      public: true
    }
  },

  // SEO Routes: Pages de Villes (Ex: /villes/toulon)
  // Le préfixe /villes/ évite que cette route intercepte par erreur des pages comme /search lors d'un F5
  {
    path: '/villes/:city',
    name: 'CityPage',
    component: CityPageView,
    meta: {
      seoPage: true,
      prerender: true
    }
  },

  // SEO Routes: Combinaisons Activités-Villes (Ex: /reserver/coiffeur/toulon)
  {
    path: '/reserver/:activity/:city',
    name: 'ActivityCity',
    component: ActivityCityView,
    meta: {
      seoPage: true,
      prerender: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 🛡️ Guard de navigation global pour vérifier l'authentification client
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('clientToken')

    if (!token) {
      return next({ name: 'signup', query: { redirect: to.fullPath } })
    }

    try {
      const response = await fetch('https://bookmysalon-967a856b16b6.herokuapp.com/api/clients/verify-token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error('Token invalide ou expiré')
      }

      next() // ✅ Token valide, on continue la navigation
    } catch (error) {
      console.error('Erreur de vérification de token :', error.message)
      localStorage.removeItem('clientToken') // 🧹 Nettoyage du token expiré
      next({ name: 'signup' }) // 🔁 Redirection vers l'inscription/connexion
    }
  } else {
    next() // ✅ Route publique
  }
})

export default router